import React from 'react';
import { Box, Typography, Divider } from '@mui/material';
import { colors, fonts, spacing, shadows } from '../../constants';

const EmailDivider = ({ text = 'or Sign in with Email' }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', mb: spacing.md, my: spacing.md }}>
      <Divider 
        sx={{ 
          flexGrow: 1,
          borderColor: colors.borderLight,
          borderWidth: '1px',
          boxShadow: shadows.sm,
        }} 
      />
      <Typography
        variant="body2"
        sx={{
          px: spacing.md,
          color: colors.textTertiary,
          fontSize: fonts.fontSizeSm,
          fontWeight: fonts.weightMedium,
          letterSpacing: '0.02em',
        }}
      >
        {text}
      </Typography>
      <Divider 
        sx={{ 
          flexGrow: 1,
          borderColor: colors.borderLight,
          borderWidth: '1px',
          boxShadow: shadows.sm,
        }} 
      />
    </Box>
  );
};

export default EmailDivider;

